import { useContext, useEffect, useState } from 'react';
import { useDebounceCallback } from '@react-hook/debounce';
import MetricsInspectionContext from '../../../state/context';
import {
  entitesAdditionalColumns,
  mapActivityTypeToEntitiesUrl
} from './entities.utils';
import axios from 'common/requester';

const useEntitiesAttributes = () => {
  const {
    state: {
      filters: { activityType },
      scatterEntitiesIds: entitiesIds
    }
  } = useContext(MetricsInspectionContext);
  const [isLoading, setIsLoading] = useState(false);
  const [entities, setEntities] = useState([]);

  const entitiesIdToAttributes = entities.reduce(
    (acc, entity) => ({
      ...acc,
      [entity.id]: entity
    }),
    {}
  );

  const fetchEntities = useDebounceCallback(async () => {
    try {
      const res = await axios.post(mapActivityTypeToEntitiesUrl[activityType], {
        ids: entitiesIds,
        additional_columns: entitesAdditionalColumns[activityType]
      });
      setEntities(res);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  }, 500);

  useEffect(() => {
    if (entitiesIds?.length > 0) {
      setIsLoading(true);
      fetchEntities();
    }
  }, [entitiesIds?.length]);

  return {
    ...entitiesIdToAttributes,
    isLoading
  };
};

export default useEntitiesAttributes;
